import React from 'react'
import { executeRecaptcha, loadRecaptchaScript } from '~/util/recaptcha'

export default class BaseReviewForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
    }
    this.onClickSubmit = this.handleClickSubmit.bind(this)
  }

  componentDidMount() {
    if (this.props.recaptchaSiteKey) {
      loadRecaptchaScript(this.props.recaptchaSiteKey).catch(error => {
        console.error('failed to preload reCAPTCHA script:', error)
      })
    }
  }

  async handleClickSubmit(event) {
    event.preventDefault()
    if (this.state.isSubmitting) return
    this.setState({ isSubmitting: true })
    try {
      let token = null
      if (this.props.recaptchaSiteKey)
        token = await executeRecaptcha(this.props.recaptchaSiteKey, 'submit_review')
      await this.props.reviewFormStore.postReview(this.createPostParams(token))
    } catch (error) {
      console.error('submit failed:', error)
    } finally {
      this.setState({ isSubmitting: false })
    }
  }

  createPostParams() {}
}
